import React from 'react';
import { Select } from 'antd';
import { AsoScenarioAdditionalOneStepAdjustment } from '@ydistri/api-sdk';

const options = [
  { label: 'None', value: AsoScenarioAdditionalOneStepAdjustment.None },
  {
    label: 'Max Picking Positions for one SKU',
    value: AsoScenarioAdditionalOneStepAdjustment.MaxPickingPositionsForOneSku,
  },
  {
    label: 'Use Set as Max Quantity for one step',
    value: AsoScenarioAdditionalOneStepAdjustment.UseSetAsMaxQuantityForOneStep,
  },
];

interface AsoScenarioAdditionalOneStepAdjustmentSelectorProps {
  value: AsoScenarioAdditionalOneStepAdjustment;
  onChange: (value: AsoScenarioAdditionalOneStepAdjustment) => void;
}

const AsoScenarioAdditionalOneStepAdjustmentSelector: React.FC<
  AsoScenarioAdditionalOneStepAdjustmentSelectorProps
> = ({ value, onChange }) => (
  <Select<AsoScenarioAdditionalOneStepAdjustment>
    style={{ minWidth: 200 }}
    value={value}
    onChange={onChange}
    options={options}
  />
);

export default AsoScenarioAdditionalOneStepAdjustmentSelector;
